import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { useLoggedInUser } from "../../../../utils";

import { LanguageGlobeIcon, languages } from "./common";
import {
    type LanguageSelectorProps,
    default as LanguageSelectorSync
} from "./language-selector";

const containerStyles = css({
    color: "#42526e",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center"
});

const labelStyles = css({
    marginInlineStart: token("space.050"),
    fontSize: "0.875rem"
});

const arrowStyles = css({
    marginInlineStart: token("space.050"),
    fontSize: "1.5rem"
});

const SelectorFallback = ({ label }: { label: string }) => {
    return (
        <div css={containerStyles}>
            <LanguageGlobeIcon color={"#42526e"} />
            <span css={labelStyles}>{label}</span>
            <span css={arrowStyles} aria-hidden="true">
                ▾
            </span>
        </div>
    );
};

export const LanguageSelector = ({
    selectedLanguage,
    onLanguageChangeHandler,
    className,
    testId
}: LanguageSelectorProps) => {
    const intl = useIntl();
    const userInfo = useLoggedInUser();

    if (!selectedLanguage) {
        selectedLanguage = intl.locale || "en";
    }
    const label =
        languages.find((language) => language.value === selectedLanguage)
            ?.label ?? "English";

    if (userInfo.requestInProgress) {
        return <SelectorFallback label={label} />;
    }
    return (
        <LanguageSelectorSync
            selectedLanguage={selectedLanguage}
            onLanguageChangeHandler={onLanguageChangeHandler}
            className={className}
            testId={testId}
        />
    );
};
